import axios from "@/axios"; 
const API_URL = process.env.VUE_APP_API_BASE_URL;
export function useUserApi() {
  async function putUserData(form_data,id) {
    try {
      const response = await axios.put(API_URL + `/profiles/${id}/`,form_data);
    return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }

  async function postUserData(form_data) {
    try {
      const response = await axios.post(API_URL + `/profiles/`,form_data);
    return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  } 
  async function getUserData() {
    try {
      const response = await axios.get(API_URL + `/profiles/`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getMenuData() {
    try {
      const response = await axios.get(API_URL + `/menus/`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getBranchesData() {
    try {
      const response = await axios.get(API_URL + `/branches/`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function createBranch(form_data) {
    try {
      const response = await axios.post(API_URL + `/branches/`,form_data);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function updateBranch(id,form_data) {
    try {
      const response = await axios.put(API_URL + `/branches/${id}/`,form_data);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function deleteBranch(id) {
    try {
      const response = await axios.delete(API_URL + `/branches/${id}/`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getRoleUserData() {
    try {
      const response = await axios.get(API_URL + `/api/user-role-stats/`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function deleteUserData(id) {
    try {
      const response = await axios.delete(API_URL + `/del-user-profile/${id}/`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function holdUserData(id,hold) {
    // alert(hold)
    try {
      let from_data = {
        'status':hold
      }
      const response = await axios.put(API_URL + `/user-profile/${id}/status/`,from_data);
      return response.data;
    } catch (error) {
      console.error("Error processing data:", error);
      throw error;
    }
  }
  async function getSingleRoleData(id) {
    try {
      const response = await axios.get(API_URL + `/roles/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function statusSingleRoleData(id,active_data) {
    try {
      let from_data = {
        "active": active_data
    }
      const response = await axios.put(API_URL + `/roles/${id}/update-active/`,from_data);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  const updateRole = async (form_data, id) => {
    try {
      const response = await axios.put(`${API_URL}/roles/${id}/`, form_data);
      return response.data;
    } catch (error) {
      console.error("Error updating role:", error);
      throw error; // Rethrow the error to handle it in the caller function
    }
  };
  async function createRole(form_data) {
    try {
      const response = await axios.post(API_URL + `/roles/`,form_data);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getRole() {
    try {
      const response = await axios.get(API_URL + `/roles/`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getOltList() {
    try {
      const response = await axios.get(API_URL + `/api/v1/sg-5/get-olt_mkinfo-per/`);
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function getOltPermission(user_id) {   
      
    /* let userPromise = new Promise((resolve, reject) => {
      let user= JSON.parse(localStorage.getItem("user_data"));
      if (user) {
        resolve(user);
      } else {
        reject("User not found in localStorage");
      }
    }); */
    try {
      // const user = await userPromise;
      const user = parseInt(user_id, 10);
      const response = await axios.get(API_URL + `/api/v1/sg-5/get-olt_mkinfo/`, {
        headers: {
          'X-Custom-Header': user
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error retrieving data:", error);
      throw error;
    }
  }
  async function updatePermission(type,id,user_id) {
      /* let userPromise = new Promise((resolve, reject) => {
        let user= JSON.parse(localStorage.getItem("user_data"));
        if (user) {
          resolve(user);
        } else {
          reject("User not found in localStorage");
        }
      }); */
      try {
        // const user = await userPromise;

        const user = parseInt(user_id, 10);
        const form_data = {
                            "login_user": [user],
                            "action": type 
                          }
        const response = await axios.put(API_URL + `/olt-mkinfo-per/${id}/`, form_data, {
          headers: {
            'X-Custom-Header': user
          }
        });
        return response.data;
      } catch (error) {
        console.error("Error updating data:", error);
        throw error; 
      }
  }
  
  return {
    putUserData,
    postUserData,
    getUserData,
    getMenuData,
    getBranchesData,
    createBranch,
    deleteBranch,
    updateBranch,
    getRoleUserData,
    deleteUserData,    
    holdUserData,
    createRole,
    getRole,
    getSingleRoleData,
    statusSingleRoleData,
    updateRole,
    getOltList,
    updatePermission,
    getOltPermission
  };
}